import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';

// @ts-ignore
export class CoopValidators extends Validators {
    static required(message: string): ValidatorFn {
        if (typeof message === 'string') {
            return (control: AbstractControl) => {
                if (!isNilOrEmpty(control?.value)) {
                    return null;
                }
                return {
                    required: { message },
                };
            };
        } else {
            return <ValidatorFn>Validators.required(message);
        }
    }

    static requiredNumber(message: string): ValidatorFn {
        if (typeof message === 'string') {
            return (control: AbstractControl) => {
                if (!isNilOrEmpty(control.value)) {
                    return null;
                }
                return {
                    required: { message },
                };
            };
        } else {
            return <ValidatorFn>Validators.required(message);
        }
    }

    static pattern(pattern: string | RegExp, message?: string): ValidatorFn {
        if (!message) {
            return Validators.pattern(pattern);
        }
        return (control: AbstractControl) => {
            const output = Validators.pattern(pattern)(control);
            if (!output) {
                return null;
            }
            return {
                ...output,
                pattern: {
                    ...output.pattern,
                    message,
                },
            };
        };
    }

    static cap(): ValidatorFn {
        return (control: AbstractControl) => {
            let CAP_REGEX = new RegExp('^[0-9]{5}$');
            if (!isNilOrEmpty(control.value) && !CAP_REGEX.test(control.value)) {
                return {
                    cap: {
                        status: 'CAP non valido',
                    },
                };
            } else {
                return null;
            }
        };
    }
}
